import React from 'react';
import { ContentSection, Heading, PageWrap, Paragraph } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { trackingService } from '../../tracking/tracking.service';

export const LinkExpired = (): JSX.Element => {
  const { t } = useTranslation();

  React.useEffect(() => {
    trackingService.trackPageView('Continue: Link expired', 'Link expired');
  }, []);

  return (
    <PageWrap>
      <ContentSection className="u-text-center">
        <Heading level={3}>{t('errorPage:linkExpired:header')}</Heading>
        <Paragraph>{t('errorPage:linkExpired:content')}</Paragraph>
      </ContentSection>
    </PageWrap>
  );
};
